import URL from './url'
import http from '@/utils/httpUtils'
import { getItem, isWxPlatform } from '@/utils/comUtils'

export default {
  // 查询灰度 - new
  getSchoolGray(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GRAY, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSchoolGrayByOrgId(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GRAY_BY_ORG_ID, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 判断该用户是否是首次登入 API_ISFIRST_LOGIN
  attendanceIsFirstLogin(postData = {}) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ISFIRST_LOGIN, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班主任查询班级下的学生 API_ATTENDANCE_HEARD_MASTER
  attendanceHeardmasterSearch(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_HEARD_MASTER, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 考勤成员校验接口 API_ATTENDANCE_CHECHET
  attendanceMemberCheck(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_CHECHET, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询单个时间是否会被使用 API_ATTENDANCE_SEARCH_IS_USE
  attendanceTimeIsUseful(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_SEARCH_IS_USE, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生的考勤组日期为星期几,进行置灰处理 API_ATTENDANCE_GREY_DEAL
  attendanceGreyDeal(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_GREY_DEAL, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构下的校区部门出勤人数月统计 API_ATTENDANCE_MONTH_RECORD
  getCheckMonthStat(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_MONTH_RECORD, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询所有部门详情API_ATTENDANCE_PARTMENT_DETAILL
  getDeptLLLDailyStates(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_PARTMENT_DETAILL, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询所有部门详情API_ATTENDANCE_PARTMENT_DETAILL -new
  getDeptLLLDailyStatesNew(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_PARTMENT_DETAILL_NEW, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询所有部门月统计 API_ATTENDANCE_ALL_RECORD
  attendanceAllPartMent(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_ALL_RECORD, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 部门月统计 API_ATTENDANCE_PARTMENT_RECORD
  attendancePartMent(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_PARTMENT_RECORD, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 自定义角色部门月统计
  attendanceCustomRolePartMent(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_CUSTOM_ROLE_PARTMENT_RECORD, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询考勤组列表
  attendanceAttendanceList(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_COUNT_SEARCHATTENDANCE, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取所有考勤记录统计
  attendanceStatusAll(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_STATUS_ALL, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 迟到/早退/未打卡的详细记录 API_ATTENDANCE_DAILY_STATUS
  attendanceDailyStatus(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_DAILY_STATUS, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 请假历史详情 API_ATTENDANCE_LEAVE_DETAIL
  attendanceLeacveDetail(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_LEAVE_DETAIL, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 批量查询班级考勤统计
  attendanceStatusByClass(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_STATUS_BY_CLASS, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生考勤日历
  attendanceStatusCalendar(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_COUNT_CALENDAR, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生月考勤记录
  attendanceStudentMonth(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_COUNT_STUDENTMONTHRECORD, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 搜索学生月考勤状况或者是学生--不使用了
  getUserDayAttendanceStat(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_COUNT_SEARCHSTATUS, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 搜索学生月考勤状况或者是学生 -new
  getUserDayAttendanceStatNew(postData) {
    if (!postData.campusId && window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_COUNT_SEARCHSTATUS_NEW, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生某天的考勤情况
  attendanceDayRecord(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_COUNT_DAYRECORD, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 修改学生结果页 API_ATTENDANCE_MODIFY_RECORD
  attendanceModifyRecord(postData) {
    postData.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_MODIFY_RECORD, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生考勤的月状态以及搜索
  attendanceStatusForMonthStudents(postData) {
    return new Promise((resolve, reject) => {
      resolve([
        {
          day: 1561939200000, // 月
          dingUserId: 'ding-user-id-string-xxx', // 学生钉钉ID
          userName: 'name-xxx', // 学生钉钉ID
          headImageUrl: 'httt://xxxxx.jpg',
          checkInStates: [1, 4] // 考勤状态,-1:无效打卡，0:未打卡，1：正常上学，2：正常下学，3：迟到，4：早退，5：缺勤, 6:请假
        },
        {
          day: 1562025600000, // 月
          dingUserId: 'ding-user-id-string-xxx', // 学生钉钉ID
          userName: 'name-xxx', // 学生钉钉ID
          headImageUrl: 'httt://xxxxx.jpg',
          checkInStates: [2] // 考勤状态,-1:无效打卡，0:未打卡，1：正常上学，2：正常下学，3：迟到，4：早退，5：缺勤, 6:请假
        },
        {
          day: 1562112000000, // 月
          dingUserId: 'ding-user-id-string-xxx', // 学生钉钉ID
          userName: 'name-xxx', // 学生钉钉ID
          headImageUrl: 'httt://xxxxx.jpg',
          checkInStates: [1, 3] // 考勤状态,-1:无效打卡，0:未打卡，1：正常上学，2：正常下学，3：迟到，4：早退，5：缺勤, 6:请假
        },
        {
          day: 1562198400000, // 月
          dingUserId: 'ding-user-id-string-xxx', // 学生钉钉ID
          userName: 'name-xxx', // 学生钉钉ID
          headImageUrl: 'httt://xxxxx.jpg',
          checkInStates: [4] // 考勤状态,-1:无效打卡，0:未打卡，1：正常上学，2：正常下学，3：迟到，4：早退，5：缺勤, 6:请假
        }
      ])
    })
  },
  // API_LEAVE_AGENT_COUNT_SEARCHCLASS
  attendanceStatusForClass(postData) {
    if (window.localStorage.getItem('currentCapmusId')) {
      postData.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_COUNT_SEARCHCLASS, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 条件搜索学生考勤状态
  attendanceStatusForStudents(postData) {
    postData.campusId = window.localStorage.getItem('currentCapmusId')
    return http.get(URL.API_ATTENDANCE_STATUS_FOR_STUDENTS, postData)
  },
  // 获取学生考勤流水
  attendanceRecordsForStudent(postData) {
    postData.campusId = window.localStorage.getItem('currentCapmusId')
    return http.get(URL.API_ATTENDANCE_RECORDS_FOR_STUDENT, postData)
  },
  // 获取所有考勤组
  attendanceGroup(postData) {
    // return http.get(URL.API_ATTENDANCE_GROUP, postData)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve([
          {
            attendanceGroupId: 1, // 可为空，为空时新建，非空时更新
            schoolTime: '09:00:00', // 非空,上学时间
            homeTime: '16:30:00' // 非空，放学时间
          },
          {
            attendanceGroupId: 2, // 可为空，为空时新建，非空时更新
            schoolTime: '09:00:00', // 非空,上学时间
            homeTime: '16:30:00' // 非空，放学时间
          },
          {
            attendanceGroupId: 3, // 可为空，为空时新建，非空时更新
            schoolTime: '09:00:00', // 非空,上学时间
            homeTime: '16:30:00' // 非空，放学时间
          },
          {
            attendanceGroupId: 4, // 可为空，为空时新建，非空时更新
            schoolTime: '09:00:00', // 非空,上学时间
            homeTime: '16:30:00' // 非空，放学时间
          }
        ])
      }, 100)
    })
  },
  // 查询考勤组人员
  attendanceRange(postData) {
    postData.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_RANGE, postData)
        .then(config => {
          console.log(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 删除考勤组 API_ATTENDANCE_DELETE_GROU
  attendanceDelete(postData) {
    postData.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_DELETE_GROU, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 查询设备考勤禁用时段
  attendancetGetGroupsSearchForbitTime(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_SEARCH_FORBIT_TIME, params)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查机构所有设备的考勤禁用时段
  getDeviceListWithAttendanceTimes(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_SEARCH_ALL_FORBIT_TIME, params)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存/编辑设备考勤禁用时段API_LEAVE_AGENT_COUNT_FORBITTIME_SAVE_EDIT
  attendanceSaveAndEditForbitTime(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_AGENT_COUNT_FORBITTIME_SAVE_EDIT, params)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存考勤组API_ATTENDANCE_SAVE_GROUP
  attendanceSaveGroup(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_SAVE_GROUP, params)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑考勤组API_ATTENDANCE_EDIT_GROU
  attendanceEditGroup(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_EDIT_GROU, params)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询所有已经存在成员组的部门和人员钉钉idAPI_ATTENDANCE_SEARCH_CANNOTSELECTED
  attendanceCannotSelected(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_SEARCH_CANNOTSELECTED, params)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询考勤组详情API_ATTENDANCE_SEARCH_GROUP_DETAIL
  attendanceSearchGroupDetailId(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_SEARCH_GROUP_DETAIL, params)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取人脸统计
  async attendancetGetFaceCount(params) {
    if (window.localStorage.getItem('currentCapmusId')) {
      params.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_FACE_COUNT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取已录入人脸列表
  async attendancetGetFaceList(params) {
    if (window.localStorage.getItem('currentCapmusId')) {
      params.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_FACE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询考勤时间配置 API_ATTENDANCE_TIME
  async attendancetTime(params) {
    if (window.localStorage.getItem('currentCapmusId')) {
      params.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_TIME, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 新增/编辑考勤时间配置 API_ATTENDANCE_SAVE_EDITE_TIME
  async attendancetSaveOrEditTime(params) {
    if (window.localStorage.getItem('currentCapmusId')) {
      params.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_SAVE_EDITE_TIME, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 删除考勤时间配置 API_ATTENDANCE_DELETE_TIME_SETTING
  async attendancetDeleteTime(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_DELETE_TIME_SETTING, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 初始化标签
  async attendanceGetTags(params) {
    // params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_GET_TAGS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 使用模板配置接口
  async getAttendanceGroupByTemplate(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SCHOOL_GET_ATTENDANCE_BY_GROUP, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 设备配置/无禁用考勤时段个数
  async getDeviceDeployCount(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_GET_DEVICE_DEPLOY_COUNT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 考勤配置不完全个数接口
  async getAttendanceDeployCount(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_GET_ATTENDANCE_DEPLOY_COUNT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 考勤学生统计（校区总人数、参与考勤人数、未参与考勤人数）
  async getAttendanceStudentCount(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_GET_ATTENDANCE__STUDENT_DEPLOY_COUNT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 权限组学生统计（校区总人数、有权限的学生人数、无权限的学生人数）
  async getDoorStudentCount(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_GET_DOOR__STUDENT_DEPLOY_COUNT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 考勤报表导出
  async exportAttendanceExcel(params) {
    params.campusId = window.localStorage.getItem('currentCapmusId')
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_EXPORT_EXCEL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询模块过期时间
  async getModuleExpireDate(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_MODULE_EXPIRE_DATE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构授权模块列表
  async getModuleList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_MODULE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构最新套餐
  async getOrgSku(params = {}) {
    return new Promise((resolve, reject) => {
      // 微信平台走的是魔点校园sku
      params.platformSource = isWxPlatform()
        ? ''
        : getItem('platformSource') === '101'
        ? '1'
        : getItem('platformSource')
      http
        .get(URL.API_SCHOOL_ORG_SKU, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getOrgSku2(params) {
    return http.get(URL.API_SCHOOL_ORG_SKU, params)
  },
  // 对Banner详情按钮是否有操作权限
  async bannerOperate(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SCHOOL_COMMON_GIFT_STATUS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 为机构增加模块权限
  async addModules(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SCHOOL_ADD_MODULES, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /* new attendance */
  // 搜索学生上下学的考勤状态详情数据
  async getUserDayAttendanceStatInOutType(params) {
    if (!params.campusId && window.localStorage.getItem('currentCapmusId')) {
      params.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_USER_DAY_STATE_IN_OUT_TYPE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某个机构的某个业务是否灰度
  async getSchoolBizGray(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CAMPUS_BIZ_GRAY, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询校区/部门的月出勤信息
  async getCheckMonthStatNew(params) {
    if (!params.campusId && window.localStorage.getItem('currentCapmusId')) {
      params.campusId = window.localStorage.getItem('currentCapmusId')
    }
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_CHECK_MONTH_STATE_NEW, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某日所有的打卡时间
  async listAttendanceCheckTime(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_LIST_CHECK_TIMEs, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /* new attendance */
  // 查询某人的高亮模块
  async listModuleHighLight(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_HIGHLIGHT_MODULE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 消除某人的高亮模块
  async clearModuleHighLight(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLEAR_MODULE_HIGHLIGHT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 考勤组预览
  async getAttendanceStudentOverview(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_OVERVIEW, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询年级日统计
  async getGradeStatInOutType(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_GET_GRADE_STATE_IN_OUT_TYPE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // ////////////////////////
  // 考勤组预览
  async groupOverview(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_GROUP_OVERVIEW, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 考勤组预览
  async getGroupOverview(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_GROUP_OVERVIEW, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询存在未参与学生的班级列表
  async getExistNoAttendanceStudentClassList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_NO_ATTENDANCE_CLASS_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 未参于考勤学生列表
  async getNoAttendanceStudentList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_GROUP_GET_NO_STUDENT_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生加入考勤组
  async addGroupStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_GROUP_ADD_STUDENT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查学生详情
  async getStudentInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_GROUP_GET_STUDENT_INFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查学生考勤组
  async getByStudentId(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_GROUP_GET_BY_STUDENT_ID, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取标签统计
  async addressGetAccommodationTagStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_TAG_STATISTICS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 准备部门树
  async addressPrepare(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_PREPARE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 创建选人组件沙盒
  async addressCreate(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CREATE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取沙盒状态
  async addressGetStatus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_STSTUS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 加部门筛选条件
  async addressSelectDepts(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SELECT_GROUPS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 移除部门筛选条件
  async addressUnselectDepts(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_UNSELECT_GROUPS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 加已选学生
  async addressSelectStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SELECT_STUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 移除已选学生
  async addressUnslectStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SELECT_UNSTUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 清除所有已选择
  async addressUnslectAll(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CLEAR_ALL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询已选学生列表-有选项的班级列表
  async addressQuerySelectClasses(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_CHECKED_CLASSES, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询已选学生列表-学生列表
  async addressQuerySelectStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_CHECKED_STUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生考勤周历
  async getAttendanceWeekCalendar(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_ATTENDANCE_GET_WEEK_CALENDAR, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 提交预选项
  async addressCommitPreSelections(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_COMMIT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 取消预选项
  async addressRollbackPreSelections(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_ROLLBACK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 搜索学生信息
  async searchByName(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ATTENDANCE_SEARCH, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 搜索学生信息
  async getUserInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_USER_INFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /* New interface for attendance statistics */
  // 获取校区以及所有班级的上下学统计新接口
  async postDeptStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_POST_DEPT_STATISTICS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某天可用的考勤组
  async getAvailableByDimDay(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_AVAILABLE_BY_DIMDAY, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某天可用的考勤组以及考勤时段
  async getGroupAndTimePeriodByDimDay(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_GROUP_AND_TIME_PERIOD_BY_DIMDAY, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某个考勤组下的时段配置
  async getTimePeriodByGroupId(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_GROUP_AND_TIME_PERIOD_BY_GROUPID, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 批量保存页面浏览记录
  async savePageViewBatch(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_PAGE_VIEW_BATCH, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班主任修改考勤结果权限查询
  async getAllowModifyAttendanceResult(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_ALLOW_MODIFY_ATTENDANCE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班主任修改考勤结果权限设置
  async updateAllowModifyAttendanceResult(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_UPDATE_ALLOW_MODIFY_ATTENDANCE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  /* New interface for attendance statistics */
}
